export default __webpack_public_path__ + "d24500013a57c7e06f70e9ce6de32355.png";